import { Collection } from 'modules/core/lib/mobx-rest'

import { Operation } from 'modules/automations/store/models/Operation'

class OperationsCollection extends Collection<Operation> {
  get cacheKey(): string {
    return 'operations'
  }

  model() {
    return Operation
  }
}

export const operations = new OperationsCollection()
